export default "__VITE_ASSET__DRigpmg$__"